import { currentFinancialYear } from '@hrms/shared';
import { pad } from '../../../lib/date';

export const TAX_SECTIONS: { key: string; label: string; limit?: number }[] = [
  { key: '80C', label: '80C — PPF, ELSS, LIC, tuition, principal', limit: 150000 },
  { key: '80CCD1B', label: '80CCD(1B) — NPS additional', limit: 50000 },
  { key: '80D', label: '80D — Medical insurance', limit: 75000 },
  { key: 'HRA', label: 'HRA — Rent paid' },
  { key: '24B', label: '24(b) — Home loan interest', limit: 200000 },
  { key: '80E', label: '80E — Education loan interest' },
  { key: '80G', label: '80G — Donations' },
  { key: 'OTHER', label: 'Other' },
];

export const fyOptions = (count = 4) => {
  const start = Number(currentFinancialYear().slice(0, 4));
  return Array.from({ length: count }, (_, i) => {
    const y = start - i;
    const v = `${y}-${pad((y + 1) % 100)}`;
    return { value: v, label: `FY ${v}` };
  });
};
